import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ErrorHandleService } from './error-handle.service';
import { DashboardActivitiesResponse, DashboardGolfMemberResponse, DashboardHotelOccupancyResponse, DashboardOfficeLeaseResponse, DashboardRevenueResponse } from '../models/dashboard';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private apiUrl = `${environment.APIDEV}`;

  constructor(
    private http: HttpClient,
    private errorHandle: ErrorHandleService
  ) { }


  getDashboardOccupancy(
    startDate?: string,
    endDate?: string
  ): Observable<DashboardHotelOccupancyResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardHotelOccupancyResponse>(`${this.apiUrl}overview/hotel_occupancy`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getDashboardOfficeLease(
    startDate?: string,
    endDate?: string
  ): Observable<DashboardOfficeLeaseResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardOfficeLeaseResponse>(`${this.apiUrl}overview/office_lease`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getDashboardGolfMember(
    startDate?: string,
    endDate?: string
  ): Observable<DashboardGolfMemberResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardGolfMemberResponse>(`${this.apiUrl}overview/golf_membership`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

  getDashboardRevenue(
    startDate?: string,
    endDate?: string
  ): Observable<DashboardRevenueResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    return this.http.get<DashboardRevenueResponse>(`${this.apiUrl}overview/revenue`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }


  getDashboardSalesActivities(
    startDate?: string,
    endDate?: string,
    filter?: string
  ): Observable<DashboardActivitiesResponse> {

    let params = new HttpParams();

    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (filter) {
      params = params.set('filter', filter);
    }

    return this.http.get<DashboardActivitiesResponse>(`${this.apiUrl}overview/sales_activities`, {
      params,
      ...this.errorHandle._httpOptions()
    }).pipe(
      catchError(this.errorHandle.errorHandl)
    );
  }

}
